<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/report/page/mould_maintain_order_export_gld"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujubaoyangdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('baoyangleixing')">
            <yi_dictionary_select size="small" :max="1" :type="'MOULD_MAINTAIN_TYPE'" :ids.sync="yt.conditions.type" :showOptionIds="['0','1','4']"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baoyangzhuangtai')">
            <yi_dictionary_select :type="'MOULD_MAINTAIN_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuabaoyangshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planTimeStart" :end.sync="yt.conditions.planTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog)" v-if="utils.checkPower('web_mold_management_maintenance_execution_create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养执行-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button :loading="exportLoading" size="mini" @click="exportDetail()" v-if="utils.checkPower('web_mold_management_maintenance_execution_export_detail')" type="primary">
          {{ $t('daochumingxixiang') }}
        </el-button>
      </template>
      <template #tupian="scope">

        <yi_upload :readOnly="true" :ids.sync="scope.row.imgInfoIds" :limit="5"> </yi_upload>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading"  @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row,'w2')">{{$t('baoyangxiang')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="yt.get(1)">
        <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('mujubianhao/mingcheng')" label-width="210px" :required="true" size="mini">
                <yi_cross_select :max="1" :multiple="false" :component="'web_base_mould_list'" :ids.sync="yt.editObj.mouldId">
                </yi_cross_select>
            </el-form-item>
            <!-- 保养方式,默认选中,不可修改 ，只做显示，不绑定值，后台默认值为“临时保养”-->
            <el-form-item :label="$t('baoyangleixing')" :required="true" label-width="210px">
              <el-input :value="$t('linshibaoyang')" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuabaoyangshijian')" :required="true" label-width="210px">
              <yi_time_input :format="'yyyy-MM-dd'" :time.sync="yt.editObj.planTime" :is_current="true" :type="'date'"></yi_time_input>
            </el-form-item>
            <el-form-item :required="true" :label="$t('yujibaoyanghaoshi(xiaoshi)')" label-width="210px">
              <yi_number_input :min="1" :type="number" :start.sync="yt.editObj.timeConsuming"></yi_number_input>
            </el-form-item>
            <p style="font-size: 18px;">{{ $t('baoyangxiang') }}</p>
            <el-form-item :label="$t('baoyangneirong')" :required="true" label-width="160px"> </el-form-item>
            <el-form-item :label="$t('zhuyishixiang')" :required="true" label-width="210px"> </el-form-item>
            <el-form-item :label="$t('beizhu')" label-width="205px"> </el-form-item>
            <el-form-item v-for="(item, index) in yt.editObj.itemList" :key="index" label-width="30px" size="mini">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :maxlength="200" v-model="item.content" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :maxlength="200" v-model="item.carefully" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :maxlength="200" v-model="item.remark" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
            </el-form-item>
            <br />
            <el-form-item label-width="30px" size="mini">
              <el-col :span="4">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('tianjiayitiaobaoyangxiang') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/custom/gelanda/maintain/insertTemp')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 保养项 -->
      <template v-if="yt.editObj.action == 'baoyangxiang'">
        <div class="dialog-scroller" >
          <item :item="yt.editObj"></item>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import item from './item'
import XLSX from "xlsx";
export default {
  name: 'web_mold_management_maintenance_execution_gld',
  components: {
    item
  },
  data() {
    return {
      list: [],
      imgInfoIds: [],
      exportLoading: false,
      // organizationList: [],
      columns: [{
        label: 'mujubaoyangdanhao',
        prop: 'no',
        width: 130
      }, {
        label: 'mujubianhao',
        prop: 'mouldNo',
        width: 130
      }, {
        label: 'mujubianma',
        prop: 'mouldCode',
      }, {
        label: 'mojumingcheng',
        prop: 'mouldName',
      }, {
        label: 'baoyangleixing',
        prop: 'type',
        type: 'dictionary',
        key: 'MOULD_MAINTAIN_TYPE'
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },{
        label: 'baoyangzhuangtai',
        type: 'tag',
        prop: 'status',
        tags: {
          0: {
            color: '#F56C6C',
            text: this.$t('weibaoyang')
          },
          1: {
            color: '#E6A23C',
            text: this.$t('baoyangzhong')
          },
          2: {
            color: '#67C23A',
            text: this.$t('yiwancheng')
          }
        },
      },{
        label: 'jihuabaoyangshijian',
        prop: 'planTime',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 150
        // format: 'yyyy-MM-dd:hh:mm:ss'
      }, {
        label: 'yujibaoyanghaoshi(xiaoshi)',
        prop: 'timeConsuming',
        // type: 'time',
        width: 170
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },{
        label: 'baoyangkaishishijian',
        prop: 'startTime',
        type: 'time',
        width: 150
        // format: 'yyyy-MM-dd:hh:mm:ss'
      }, {
        label: 'baoyangjieshushijian',
        prop: 'endTime',
        type: 'time',
        width: 150,

      }, {
        label: 'baoyangpingjia',
        prop: 'remark',
      },{
          label: 'tupian',
          type: 'slot',
          prop: ''
        },  {
        label: 'chuangjianren',
        prop: 'createBy',
      },{
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
        width: 150
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },  {
        label: 'caozuo',
        type: 'slot',
        width: 180,
        fixed: 'right'
      }]
    };
  },
  created() {

    setTimeout(() => {
      this.yt.conditions = {
        planTimeStart: this.begin(),
        planTimeEnd: this.end(),
      };
      this.yt.get(1);
      // this.getOrganizationList();
      this.utils.event_hub.$on('MOLD_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      })
    }, 500)

  },
  watch: {
    "yt.conditions.mouldId": {
      handler(n) {
        this.yt.conditions.mouldId = n.join(',')
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end
    },
    deleteItem(key) {
      this.yt.editObj.itemList = this.yt.editObj.itemList.filter((item, index) => {
        return index !== key;
      });
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng') {
        editObj.itemList = [
          {
            content: '',
            carefully: '',
            remark: ''
          }
        ];
      }
      return editObj;
    },
    addItem() {
      this.yt.editObj.itemList.push({
        part: '',
        content: '',
        attention: ''
      });
    },
    imgIdsToList(row){
      let arr=[];
      // if(row.imgInfoIds){
      //   arr = row.imgInfoIds.split(",")
      // }
      return arr
    },
    exportExcel() {
      this.yt.exportLoading = true
      let params = this.yt.conditions
      return this.http.get('/web/report/export/mould_maintain_order_export_gld', {
        params
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(()=>{
        this.yt.exportLoading = false
      })
    },
    // 重置
    clear() {
      this.yt.conditions = {
        pageNum: 1,
        pageSize: 10
      }
      this.yt.get(1)
    },
    exportDetail() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/custom/gelanda/maintain/exportDetail?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = [this.$t('mujubaoyangdanhao'),this.$t('mujubianhao'),this.$t('mojumingcheng'),this.$t('baoyangleixing'),this.$t('baoyangzhuangtai'),this.$t('jihuabaoyangshijian'),
          this.$t('baoyangneirong'),this.$t('zhuyishixiang'),this.$t('beizhu'),this.$t('zhuangtai'),this.$t('caozuoren'),this.$t('baoyangbeizhu')];
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          if(listData[i].itemList!=null && listData[i].itemList!=undefined && listData[i].itemList.length > 0){
            for (let j = 0; j < listData[i].itemList.length; j++) {
              let dataArr = [];
              let item = listData[i].itemList[j];
              dataArr[tableFirst.indexOf(this.$t('mujubaoyangdanhao'))] = listData[i].no;
              dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = listData[i].mouldNo? listData[i].mouldNo:'';
              dataArr[tableFirst.indexOf(this.$t('mojumingcheng'))] = listData[i].mouldName? listData[i].mouldName:'';
              dataArr[tableFirst.indexOf(this.$t('baoyangleixing'))] = this.$t(this.store.state.dictJson['MOULD_MAINTAIN_TYPE'][listData[i].type]);
              dataArr[tableFirst.indexOf(this.$t('baoyangzhuangtai'))] = this.$t(this.store.state.dictJson['MOULD_MAINTAIN_STATUS'][listData[i].status]);
              dataArr[tableFirst.indexOf(this.$t('jihuabaoyangshijian'))] = this.dayjs(listData[i].planTime).format('YYYY-MM-DD HH:mm:ss');
              dataArr[tableFirst.indexOf(this.$t('baoyangneirong'))] = item.content? item.content:'';
              dataArr[tableFirst.indexOf(this.$t('zhuyishixiang'))] = item.carefully? item.carefully:'';
              dataArr[tableFirst.indexOf(this.$t('beizhu'))] = item.remark? item.remark:'';
              dataArr[tableFirst.indexOf(this.$t('zhuangtai'))] = this.$t(this.store.state.dictJson['MOULD_MAINTAIN_STATUS'][item.status]);
              dataArr[tableFirst.indexOf(this.$t('caozuoren'))] = item.operatorName ? item.operatorName : '';
              dataArr[tableFirst.indexOf(this.$t('baoyangbeizhu'))] = item.maintainRemark ? item.maintainRemark : '';
              tableData.push(dataArr);
            }
          }else {
            let dataArr = [];
            dataArr[tableFirst.indexOf(this.$t('mujubaoyangdanhao'))] = listData[i].no;
            dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = listData[i].mouldNo? listData[i].mouldNo:'';
            dataArr[tableFirst.indexOf(this.$t('mojumingcheng'))] = listData[i].mouldName? listData[i].mouldName:'';
            dataArr[tableFirst.indexOf(this.$t('baoyangleixing'))] = this.$t(this.store.state.dictJson['MOULD_MAINTAIN_TYPE'][listData[i].type]);
            dataArr[tableFirst.indexOf(this.$t('baoyangzhuangtai'))] = this.$t(this.store.state.dictJson['MOULD_MAINTAIN_STATUS'][listData[i].status]);
            dataArr[tableFirst.indexOf(this.$t('jihuabaoyangshijian'))] = this.dayjs(listData[i].planTime).format('YYYY-MM-DD HH:mm:ss');
            tableData.push(dataArr);
          }
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具保养_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  }
};
</script>
